import src from "IMAGE";
export default { src, width: 1500, height: 470, blurWidth: 0, blurHeight: 0};
